(function () {
  if (!window.location.pathname.includes('/collections/')) return;

  const params = new URLSearchParams(window.location.search);

  if (!params.has('filter.v.availability')) {
    params.set('filter.v.availability', '1');
    window.location.replace(window.location.pathname + '?' + params.toString());
  }
})();